module.exports = __webpack_public_path__ + "assets/img/7a7c7dca2cb14f3e4b56e7dcc622e653.png";